import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

type Entry = {
  rank: number;
  anon_email: string;
  max_matches: number;
  best_tier: string;
  game: string;
};

export default function Leaderboard() {
  const [entries, setEntries] = useState<Entry[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/api/v1/picks/leaderboard')
      .then((r) => r.ok ? r.json() : [])
      .then((d) => { setEntries(d); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-sky-50 to-indigo-50 p-4">
      <div className="mx-auto max-w-lg">
        <Link to="/" className="mb-6 block text-xs text-slate-400 hover:text-slate-600">← Back to picks</Link>
        <h1 className="mb-2 text-2xl font-bold text-slate-900">Leaderboard</h1>
        <p className="mb-6 text-sm text-slate-500">Top 10 players by best match count on this platform. Emails anonymised.</p>

        {loading && <p className="text-sm text-slate-500">Loading…</p>}

        {!loading && entries.length === 0 && (
          <div className="rounded-2xl border border-slate-200 bg-white p-8 text-center">
            <p className="text-slate-500">No results yet. Be the first to save a pick!</p>
            <Link to="/register" className="mt-4 inline-block rounded-full bg-sky-600 px-6 py-2 text-sm font-semibold text-white">
              Register free
            </Link>
          </div>
        )}

        <div className="space-y-2">
          {entries.map((e) => (
            <div
              key={e.rank}
              className={`flex items-center gap-4 rounded-2xl border p-4 shadow-sm ${
                e.rank === 1 ? 'border-yellow-300 bg-yellow-50' : 'border-slate-200 bg-white'
              }`}
            >
              <span className={`flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full text-sm font-bold ${
                e.rank === 1 ? 'bg-yellow-400 text-white' :
                e.rank === 2 ? 'bg-slate-400 text-white' :
                e.rank === 3 ? 'bg-amber-600 text-white' :
                'bg-slate-200 text-slate-700'
              }`}>{e.rank}</span>
              <div className="flex-1 min-w-0">
                <p className="truncate text-sm font-semibold text-slate-800">{e.anon_email}</p>
                <p className="text-xs text-slate-500">{e.game.replace(/_/g, ' ')} · {e.best_tier}</p>
              </div>
              <span className="text-sm font-bold text-sky-700">{e.max_matches} matches</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
